import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-md-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "bg-transparent text-primary transition p-0 border-0"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol" })
], -1)
const _hoisted_4 = { class: "d-sm-flex align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Ajouter un reglement groupe", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  class: "default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mt-10 mt-md-0",
  type: "button"
}, [
  /*#__PURE__*/_createTextVNode(" Export "),
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-file-1 position-relative ms-5 top-2 fs-15" })
], -1)
const _hoisted_8 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " # "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Reference "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " Date "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Agent "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Montant "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
    }, " Actions ")
  ])
], -1)
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_18 = { class: "dropdown" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge text-white bg-primary fs-15 dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createTextVNode(" Actions "),
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
], -1)
const _hoisted_20 = { class: "dropdown-menu" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_23 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }
const _hoisted_24 = {
  class: "modal fade createNewModal",
  id: "AddElementModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_25 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_26 = { class: "modal-content p-15 p-md-40" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title fw-bold text-black" }, "Détails")
], -1)
const _hoisted_28 = { class: "modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25" }
const _hoisted_29 = { class: "table-responsive" }
const _hoisted_30 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " # "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Date "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " client "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Montant "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Reste A payer ")
  ])
], -1)
const _hoisted_32 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_33 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_34 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_35 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_36 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "3",
  class: "shadow-none lh-1 fw-medium text-paragraph"
}, " Total ", -1)
const _hoisted_38 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("td", null, " - ", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close shadow-none",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          class: "search-box position-relative",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
            class: "form-control shadow-none text-black rounded-0 border-0",
            placeholder: "Rechercher un encaissement groupé"
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _hoisted_3
        ], 32),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/Ajout-reglement-groupe",
            class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _hoisted_6
            ]),
            _: 1
          }),
          _hoisted_7
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("table", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elements, (reg, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_12, _toDisplayString(reg.id), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(reg.reference), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.format_date(reg.dateReglement)), 1),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(reg.utilisateur.nom+" "+ reg.utilisateur.prenoms), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(reg.montantTotal), 1),
                  _createElementVNode("td", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("ul", _hoisted_20, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#AddElementModal",
                            onClick: ($event: any) => (_ctx.detail(reg.id, reg.montantTotal))
                          }, [
                            _hoisted_22,
                            _createTextVNode(" Detail ")
                          ], 8, _hoisted_21)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("table", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reglements, (re, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_32, _toDisplayString(re.id), 1),
                      _createElementVNode("td", _hoisted_33, _toDisplayString(_ctx.format_date(re.dateReglement)), 1),
                      _createElementVNode("td", _hoisted_34, _toDisplayString(" [ "+ re.vente.client.code +" ] "+ re.vente.client.nom+" "+re.vente.client.prenoms), 1),
                      _createElementVNode("td", _hoisted_35, _toDisplayString(re.montant), 1),
                      _createElementVNode("td", _hoisted_36, _toDisplayString(re.restAPayer), 1)
                    ]))
                  }), 128)),
                  _createElementVNode("tr", null, [
                    _hoisted_37,
                    _createElementVNode("td", _hoisted_38, _toDisplayString(_ctx.total), 1),
                    _hoisted_39
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_40
        ])
      ])
    ])
  ], 64))
}